import React, { useEffect, useState } from "react";
import { Avatar, Card, theme } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Meta from "antd/lib/card/Meta";
import { updateNotificationsCount } from "features/notificationsSlice";
import { setActiveMessageId } from "features/messagesSlice";
import { useHistory } from "react-router";
import { fetchAccountById } from "utils/api";
import { ACCOUNT_TYPE } from "utils/consts";
import { useMediaQuery } from "react-responsive";
import { css } from "@emotion/css";

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Wrap the matched part of `text` in a yellow highlight while searching.
const highlightMatch = (text, query) => {
  const trimmed = (query || "").trim();
  if (!trimmed || !text) return text;
  const parts = String(text).split(
    new RegExp(`(${escapeRegExp(trimmed)})`, "gi")
  );
  return parts.map((part, index) =>
    part.toLowerCase() === trimmed.toLowerCase() ? (
      <mark key={index} style={{ backgroundColor: "yellow", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

function MessageCard(props) {
  const { active, searchQuery } = props;
  const {
    token: {
      colorPrimaryBg,
      colorPrimaryBorder,
      colorBorderSecondary,
      colorPrimary,
    },
  } = theme.useToken();
  const history = useHistory();
  const dispatch = useDispatch();
  const thisUserId = useSelector((state) => state.user.user?._id?.$oid);
  const { latestMessage, otherId, otherUser } = props.chat;
  const [accountData, setAccountData] = useState({});
  const isMobile = useMediaQuery({ query: `(max-width: 761px)` });

  const openMessage = () => {
    dispatch(
      updateNotificationsCount({ recipient: thisUserId, sender: otherId })
    );
    dispatch(setActiveMessageId({ activeMessageId: thisUserId }));
    history.push(`/messages/${otherId}?user_type=${otherUser.user_type}`);
    if (isMobile) {
      var sidebar = document.getElementsByClassName("ant-layout-sider");
      if (sidebar.length > 0) {
        sidebar[0].style.display = "none";
      }
      var message_container = document.getElementsByClassName(
        "conversation-container"
      );
      if (message_container.length > 0) {
        message_container[0].style.display = "flex";
      }
    }
  };

  useEffect(() => {
    async function fetchAccount() {
      var otherType = otherUser.user_type;
      var account =
        otherType == null ? null : await fetchAccountById(otherId, otherType);
      if (account) {
        setAccountData(account);
      } else {
        account = await fetchAccountById(otherId, ACCOUNT_TYPE.MENTEE);
        setAccountData(account);
      }
      if (isMobile) {
        setTimeout(() => {
          var message_container = document.getElementsByClassName(
            "conversation-container"
          );
          if (message_container.length > 0) {
            message_container[0].style.display = "none";
          }
        }, 1000);
      }
    }
    fetchAccount();
    if (isMobile) {
      setTimeout(() => {
        var message_container = document.getElementsByClassName(
          "conversation-container"
        );
        if (message_container.length > 0) {
          message_container[0].style.display = "none";
        }
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeCardStyle = css`
    background: ${colorPrimaryBg};
    border: 1px solid ${colorPrimaryBorder};

    :hover {
      background: ${colorPrimaryBg};
    }
  `;

  const descriptionClass = css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
  `;

  return (
    <Card
      onClick={openMessage}
      className={css`
        width: 100%;
        margin-bottom: 3%;
        border: 1px solid "#e8e8e8";
        box-sizing: border-box;
        border-radius: 7px;

        :hover {
          background-color: ${colorBorderSecondary};
          border-color: ${colorPrimaryBorder};
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        }

        ${active && activeCardStyle}
      `}
    >
      {otherUser ? (
        <div
          className={
            active
              ? css`
                  div {
                    color: ${colorPrimary} !important;
                  }
                `
              : undefined
          }
        >
          <Meta
            avatar={<Avatar src={otherUser.image} />}
            title={highlightMatch(
              otherUser.name ? otherUser.name : accountData.organization,
              searchQuery
            )}
            description={
              <span className={descriptionClass}>{latestMessage.body}</span>
            }
          />
        </div>
      ) : null}
    </Card>
  );
}

export default MessageCard;
